// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let AlertCondition = {
    MORE: 0,
    LESS: 1,
    MORE_EQUAL: 2,
    LESS_EQUAL: 3
}
export let AlertConditionMap = {
    0: "Greater",
    1: "Less",
    2: "Greater or equal",
    3: "Less or equal"
}
export let AlertSymbolConditionMap = {
    0: ">",
    1: "<",
    2: ">=",
    3: "<="
}